import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

Router.prototype.goBack = function () {
  // this.isBack = true
  this.toBack = true
  this.history.go(-1)
}

export default new Router({
  base: '/',
  mode: 'history',
  routes: [
    {
      path: '/login',
      name: 'login',
      component: resolve => require(['@/views/login/login'], resolve),
      meta: {
        title: '登录',
        keepAlive: true,
        saName: 'LoginActivity'
      }
    },
    {
      path: '/oldIndex',
      name: 'index',
      component: resolve => require(['@/views/index/index'], resolve),
      meta: {
        title: '首页',
        isBack: false,
        keepAlive: true
      }
    },
    {
      path: '/focus/product', // focus:订阅，product:商品
      name: 'focus',
      component: resolve => require(['@/views/focus/focus'], resolve),
      meta: {
        title: '订阅',
        isBack: false,
        keepAlive: true,
        saName: 'AttentionFragment'
      }
    },
    {
      path: '/focus/focus', // focus:订阅，product:商品
      name: 'focus',
      component: resolve => require(['@/views/focus/focus'], resolve),
      meta: {
        title: '订阅',
        isBack: false,
        keepAlive: true,
        saName: 'ItemAttentionFragment'
      }
    },
    {
      path: '/myOld',
      name: 'myOld',
      component: resolve => require(['@/views/my/my'], resolve),
      meta: {
        title: '我的',
        isBack: false,
        keepAlive: true
      }
    },
    {
      path: '/myInvite',
      name: 'myInvite',
      component: resolve => require(['@/views/invite/myInvite'], resolve),
      meta: {
        title: '我的邀请',
        isBack: false,
        keepAlive: true,
        saName: 'MyInviteActivity'
      }
    },
    {
      path: '/discover/:type', // activity:活动，news:资讯，market：集市
      name: 'discover',
      component: resolve => require(['@/views/discover/discover'], resolve),
      meta: {
        title: '发现',
        isBack: false,
        keepAlive: true
      }
    },
    {
      path: '/activityList',
      name: 'activityList',
      component: resolve => require(['@/views/discover/activityList'], resolve),
      meta: {
        title: '活动',
        isBack: false,
        keepAlive: true
      }
    },
    {
      path: '/activityDetail/:id',
      name: 'activityDetail',
      component: resolve => require(['@/views/discover/activityDetail'], resolve),
      meta: {
        title: '活动详情',
        keepAlive: true
      }
    },
    {
      path: '/jishiDetail/:id',
      name: 'activityDetail',
      component: resolve => require(['@/views/discover/activityDetail'], resolve),
      meta: {
        title: '集市详情',
        keepAlive: true
      }
    },
    {
      path: '/newsDetail/news/:id',
      name: 'news',
      component: resolve => require(['@/views/discover/newsDetail'], resolve),
      meta: {
        title: '资讯详情',
        isBack: false,
        keepAlive: true
      }
    },
    {
      path: '/newsDetail/article/:id',
      name: 'newsDetail',
      component: resolve => require(['@/views/discover/newsDetail'], resolve),
      meta: {
        title: '文章详情',
        isBack: false,
        keepAlive: true,
        saName: 'InformationDetailsActivity'
      }
    },
    {
      path: '/WZDetail/article/:id',
      name: 'WZDetail',
      component: resolve => require(['@/views/pintie/WZDetail'], resolve),
      meta: {
        title: '文章详情',
        isBack: false,
        keepAlive: true
      }
    },
    {
      path: '/newsDetail/discuss/:id',
      name: 'discuss',
      component: resolve => require(['@/views/discover/newsDetail'], resolve),
      meta: {
        title: '热门讨论',
        isBack: false,
        keepAlive: true
      }
    },
    {
      path: '/personMsg',
      name: 'personMsg',
      component: resolve => require(['@/views/my/personMsg'], resolve),
      meta: {
        title: '个人信息',
        isBack: false,
        keepAlive: true,
        saName: 'MyInformationActivity'
      }
    },
    {
      path: '/myCoupon/:type',
      name: 'myCoupon',
      component: resolve => require(['@/views/coupon/myCoupon'], resolve),
      meta: {
        title: '我的米券',
        isBack: false,
        keepAlive: true,
        saName: 'MyMijuanActivity'
      }
    },
    {
      path: '/couponGive',
      name: 'couponGive',
      component: resolve => require(['@/views/coupon/couponGive'], resolve),
      meta: {
        title: '米券转赠',
        isBack: false,
        keepAlive: true
      }
    },
    {
      path: '/myActivity',
      name: 'myActivity',
      component: resolve => require(['@/views/my/myActivity'], resolve),
      meta: {
        title: '我参加的活动'
      }
    },
    {
      path: '/myConserve/:type',
      name: 'myConserve',
      component: resolve => require(['@/views/my/myConserve'], resolve),
      meta: {
        title: '我的囤货',
        isBack: false,
        keepAlive: true,
        saName: 'MyStockPileActivity'
      }
    },
    {
      path: '/myConserve1/:type',
      name: 'myConserve1',
      component: resolve => require(['@/views/zhishangwu/myConserve'], resolve),
      meta: {
        title: '纸上物囤货',
        isBack: false,
        keepAlive: true
      }
    },
    {
      path: '/myWallet',
      name: 'myWallet',
      component: resolve => require(['@/views/my/myWallet'], resolve),
      meta: {
        title: '我的钱包',
        isBack: false,
        keepAlive: true,
        saName: 'MyMainWalletActivity'
      }
    },
    {
      path: '/myFocus',
      name: 'myFocus',
      component: resolve => require(['@/views/my/myFocus'], resolve),
      meta: {
        title: '我的订阅',
        isBack: false,
        keepAlive: true,
        saName: 'MyAttentionActivity'
      }
    },
    {
      path: '/myFans',
      name: 'myFans',
      component: resolve => require(['@/views/my/myFans'], resolve),
      meta: {
        title: '我的粉丝',
        isBack: false,
        keepAlive: true,
        saName: 'MyAttentionActivity'
      }
    },
    {
      path: '/myArticle',
      name: 'myArticle',
      component: resolve => require(['@/views/my/myArticle'], resolve),
      meta: {
        title: '我的文章',
        isBack: false,
        keepAlive: true
      }
    },
    {
      path: '/myComment/:type', // product商品，article文章
      name: 'myComment',
      component: resolve => require(['@/views/my/myComment'], resolve),
      meta: {
        title: '我的评论',
        isBack: false,
        keepAlive: true,
        saName: 'MyReponseActivity'
      }
    },
    {
      path: '/buyCar',
      name: 'buyCar',
      component: resolve => require(['@/views/my/buyCar'], resolve),
      meta: {
        title: '购物车',
        isBack: false,
        keepAlive: true,
        saName: 'ShoppingCartActivity'
      }
    },
    {
      path: '/activitySign/:id',
      name: 'activitySign',
      component: resolve => require(['@/views/discover/activitySign'], resolve),
      meta: {
        title: '活动报名',
        isBack: false,
        keepAlive: true
      }
    },
    {
      path: '/darenList',
      name: 'darenList',
      component: resolve => require(['@/views/daren/darenList'], resolve),
      meta: {
        title: '达人列表'
      }
    },
    {
      path: '/associationRec/:type', // association社团，painter画师
      name: 'associationRec',
      component: resolve => require(['@/views/daren/associationRec'], resolve),
      meta: {
        title: '社团推荐',
        isBack: false,
        keepAlive: true,
        saName: 'CommunityActivity'
      }
    },
    {
      path: '/associationList',
      name: 'associationList',
      component: resolve => require(['@/views/daren/associationList'], resolve),
      meta: {
        title: '社团列表'
      }
    },
    {
      path: '/userDetail/:id/:showNotice', // 用户id，类型，是否有公告
      name: 'userDetail',
      component: resolve => require(['@/views/daren/userDetail'], resolve),
      meta: {
        title: '用户主页',
        isBack: false,
        keepAlive: true,
        saName: 'PersonalDetailsActivity'
      }
    },
    {
      path: '/addressManage',
      name: 'addressManage',
      component: resolve => require(['@/views/address/addressManage'], resolve),
      meta: {
        title: '地址管理',
        isBack: false,
        keepAlive: true,
        saName: 'UserAddressActivity'
      }
    },
    {
      path: '/newAddress',
      name: 'newAddress',
      component: resolve => require(['@/views/address/newAddress'], resolve),
      meta: {
        title: '新建收货人',
        keepAlive: true,
        saName: 'NewAddressActivity'
      }
    },
    {
      path: '/addressEdit',
      name: 'addressEdit',
      component: resolve => require(['@/views/address/addressEdit'], resolve),
      meta: {
        title: '地址编辑',
        keepAlive: true
      }
    },
    {
      path: '/hotlist',
      name: 'hotlist',
      component: resolve => require(['@/views/pintuan/hotList'], resolve),
      meta: {
        title: '热销榜单',
        isBack: false,
        keepAlive: true,
        saName: 'MainEnterShaixuanActivity'
      }
    },
    {
      path: '/saleCalendar',
      name: 'saleCalendar',
      component: resolve => require(['@/views/pintuan/saleCalendar'], resolve),
      meta: {
        title: '开售日历',
        isBack: false,
        keepAlive: true,
        saName: 'MainEnterShaixuanActivity'
      }
    },
    {
      path: '/pintuan/:type', // common拼团，new最新拼团
      name: 'pintuan',
      component: resolve => require(['@/views/pintuan/pintuan'], resolve),
      meta: {
        title: '拼团',
        isBack: false,
        keepAlive: true,
        saName: 'MainEnterShaixuanActivity'
      }
    },
    {
      path: '/newWorkmanship/:type', // common拼团，new最新拼团
      name: 'newWorkmanship',
      component: resolve => require(['@/views/pintuan/pintuan'], resolve),
      meta: {
        title: '拼团',
        isBack: false,
        keepAlive: true,
        saName: 'MainEnterShaixuanActivity'
      }
    },
    {
      path: '/pintuanSku/:type', // common拼团，new最新拼团
      name: 'pintuan',
      component: resolve => require(['@/views/pintuan/pintuan_sku'], resolve),
      meta: {
        title: '拼团',
        isBack: false,
        keepAlive: true,
        saName: 'MainEnterShaixuanActivity'
      }
    },
    {
      path: '/pintuanDetail/:id',
      name: 'pintuanDetail',
      component: resolve => require(['@/views/pintuan/pintuanDetail'], resolve),
      meta: {
        title: '拼团详情',
        isBack: false,
        keepAlive: true,
        saName: 'PintuanMainActivity'
      }
    },
    {
      path: '/pintuanMain/:id',
      name: 'pintuanMain',
      component: resolve => require(['@/views/pintuan/pintuanMain'], resolve),
      meta: {
        title: '拼团主页'
      }
    },
    {
      path: '/pintuanSoonEnd',
      name: 'pintuanSoonEnd',
      component: resolve => require(['@/views/pintuan/pintuanSoonEnd'], resolve),
      meta: {
        title: '即将截团',
        isBack: false,
        keepAlive: true
      }
    },
    {
      path: '/pintuanSoonStart',
      name: 'pintuanSoonStart',
      component: resolve => require(['@/views/pintuan/pintuanSoonStart'], resolve),
      meta: {
        title: '即将开团',
        isBack: false,
        keepAlive: true
      }
    },
    {
      path: '/pintuanLimit',
      name: 'pintuanLimit',
      component: resolve => require(['@/views/pintuan/pintuanLimit'], resolve),
      meta: {
        title: '限时首发',
        isBack: false,
        keepAlive: true
      }
    },
    {
      path: '/orderConfirm',
      name: 'orderConfirm',
      component: resolve => require(['@/views/order/orderConfirm'], resolve),
      meta: {
        title: '订单确认',
        isBack: false,
        keepAlive: true
      }
    },
    {
      path: '/orderCartConfirm',
      name: 'orderCartConfirm',
      component: resolve => require(['@/views/order/orderCartConfirm'], resolve),
      meta: {
        title: '购物车订单确认',
        isBack: false,
        keepAlive: true
      }
    },
    {
      path: '/sendConfirm',
      name: 'sendConfirm',
      component: resolve => require(['@/views/order/sendConfirm'], resolve),
      meta: {
        title: '发货确认',
        isBack: false,
        keepAlive: true
      }
    },
    {
      path: '/sendConfirm1',
      name: 'sendConfirm',
      component: resolve => require(['@/views/zhishangwu/sendConfirm'], resolve),
      meta: {
        title: '确认发货',
        isBack: false,
        keepAlive: true
      }
    },
    {
      path: '/relativeComment',
      name: 'relativeComment',
      component: resolve => require(['@/views/pintuan/relativeComment'], resolve),
      meta: {
        title: '相关评价',
        isBack: false,
        keepAlive: true
      }
    },
    {
      path: '/pintuanSort',
      name: 'pintuanSort',
      component: resolve => require(['@/views/pintuan/pintuanSort'], resolve),
      meta: {
        title: '主题分类',
        isBack: false,
        keepAlive: true,
        saName: 'pintuanSort'
      }
    },
    {
      path: '/orderShow',
      name: 'orderShow',
      component: resolve => require(['@/views/order/orderShow'], resolve),
      meta: {
        title: '评价晒单',
        isBack: false,
        keepAlive: true
      }
    },
    {
      path: '/paySuccess/type=:type/id=:id/price=:price',
      name: 'paySuccess',
      component: resolve => require(['@/views/order/paySuccess'], resolve),
      meta: {
        title: '支付成功',
        isBack: false,
        keepAlive: true
      }
    },
    {
      path: '/sendDetail/:id',
      name: 'sendDetail',
      component: resolve => require(['@/views/order/sendDetail'], resolve),
      meta: {
        title: '发货详情',
        isBack: false,
        keepAlive: true
      }
    },
    {
      path: '/sendDetail1/:id',
      name: 'sendDetail',
      component: resolve => require(['@/views/zhishangwu/sendDetail'], resolve),
      meta: {
        title: '发货详情',
        isBack: false,
        keepAlive: true
      }
    },
    {
      path: '/searchResult',
      name: 'searchResult',
      component: resolve => require(['@/views/search/result/searchResult'], resolve),
      meta: {
        title: '搜索结果',
        isBack: false,
        keepAlive: true,
        saName: 'SearchActivity'
      }
    },
    {
      path: '/myOrder',
      name: 'myOrder',
      component: resolve => require(['@/views/order/myOrder'], resolve),
      meta: {
        title: '我的订单',
        isBack: false,
        keepAlive: true,
        saName: 'MyOrderActivity'
      }
    },
    {
      path: '/myOrder/bs1',
      name: 'myOrder',
      component: resolve => require(['@/views/order/myOrder'], resolve),
      meta: {
        title: '我的订单',
        isBack: false,
        keepAlive: true
      }
    },
    {
      path: '/myOrder/fuka',
      name: 'myOrder',
      component: resolve => require(['@/views/order/myOrder'], resolve),
      meta: {
        title: '我的订单',
        isBack: false,
        keepAlive: true
      }
    },
    {
      path: '/orderDetail',
      name: 'orderDetail',
      component: resolve => require(['@/views/order/orderDetail'], resolve),
      meta: {
        title: '订单详情',
        keepAlive: true
      }
    },
    // {
    //   path: '/samiList',
    //   name: 'samiList',
    //   component: resolve => require(["@/views/order/orderDetail"], resolve),
    //   meta: {
    //     title: '撒米',
    //     keepAlive: true
    //   }
    // },
    {
      path: '/samiDetail/:id',
      name: 'samiDetail',
      component: resolve => require(['@/views/sami/samiDetail'], resolve),
      meta: {
        title: '撒米详情',
        isBack: false,
        keepAlive: true
      }
    },
    {
      path: '/aboutSami',
      name: 'aboutSami',
      component: resolve => require(['@/views/my/aboutSami'], resolve),
      meta: {
        title: '关于撒米',
        keepAlive: true
      }
    },
    {
      path: '/samiAgreement',
      name: 'samiAgreement',
      component: resolve => require(['@/views/sami/samiAgreement'], resolve),
      meta: {
        title: '撒米用户协议',
        keepAlive: true
      }
    },
    {
      path: '/feedBack',
      name: 'feedBack',
      component: resolve => require(['@/views/my/feedBack'], resolve),
      meta: {
        title: '意见反馈',
        keepAlive: true
      }
    },
    {
      path: '/msgType',
      name: 'msgType',
      component: resolve => require(['@/views/message/msgType'], resolve),
      meta: {
        title: '消息通知',
        isBack: false,
        keepAlive: true,
        saName: 'MessageNewActivity'
      }
    },
    {
      path: '/msgList',
      name: 'msgList',
      component: resolve => require(['@/views/message/msgList'], resolve),
      meta: {
        title: '消息提醒',
        isBack: false,
        keepAlive: true,
        saName: 'MessageNotificationDetailActivity'
      }
    },
    {
      path: '/help',
      name: 'help',
      component: resolve => require(['@/views/help/help'], resolve),
      meta: {
        title: '帮助',
        keepAlive: true
      }
    },
    {
      path: '/helpDetail',
      name: 'helpDetail',
      component: resolve => require(['@/views/ideas/helpDetail'], resolve),
      meta: {
        title: '咨询',
        isBack: false,
        keepAlive: true
      }
    },
    {
      path: '/authentication',
      name: 'authentication',
      component: resolve => require(['@/views/daren/darenAuth'], resolve),
      meta: {
        title: '达人认证',
        isBack: false,
        keepAlive: true
      }
    },
    {
      path: '/subjectList',
      name: 'subjectList',
      component: resolve => require(['@/views/subject/subjectList'], resolve),
      meta: {
        title: '专题列表'
      }
    },
    {
      path: '/subject',
      name: 'subject',
      component: resolve => require(['@/views/subject/subject'], resolve),
      meta: {
        title: '专题'
      }
    },
    {
      path: '/subjectDetail',
      name: 'subjectDetail',
      component: resolve => require(['@/views/subject/subjectDetail'], resolve),
      meta: {
        title: '专题详情'
      }
    },
    {
      path: '/popularity/:type', // tape:胶带，paster:贴纸
      name: 'popularity',
      component: resolve => require(['@/views/pintuan/popularity'], resolve),
      meta: {
        title: '人气榜单',
        isBack: false,
        keepAlive: true
      }
    },
    {
      path: '/payInfo',
      name: 'payInfo',
      component: resolve => require(['@/views/order/payInfo'], resolve),
      meta: {
        title: '支付详情',
        isBack: false,
        keepAlive: true
      }
    },
    {
      path: '/modifyMobile',
      name: 'modifyMobile',
      component: resolve => require(['@/views/modifyMobile/modifyMobile'], resolve),
      meta: {
        title: '修改手机',
        isBack: false,
        keepAlive: true
      }
    },
    {
      path: '/couponExchange',
      name: 'couponExchange',
      component: resolve => require(['@/views/coupon/couponExchange'], resolve),
      meta: {
        title: '米券兑换'
      }
    },
    {
      path: '/outScore',
      name: 'outScore',
      component: resolve => require(['@/views/score/outScore'], resolve),
      meta: {
        title: '过期积分查询',
        isBack: false,
        keepAlive: true,
        saName: 'Queryofexpiredcredits'
      }
    },
    {
      path: '/myScore',
      name: 'myScore',
      component: resolve => require(['@/views/score/myScore'], resolve),
      meta: {
        title: '我的积分',
        isBack: false,
        keepAlive: true,
        saName: 'ExchangeRecordActivity'
      }
    },
    {
      path: '/scoreStore',
      name: 'scoreStore',
      component: resolve => require(['@/views/score/scoreStore'], resolve),
      meta: {
        title: '积分商城',
        isBack: false,
        keepAlive: true,
        saName: 'InteralStoreActivity'
      }
    },
    {
      path: '/scoreDetail/:id',
      name: 'scoreDetail',
      component: resolve => require(['@/views/score/scoreDetail'], resolve),
      meta: {
        title: '积分兑换',
        isBack: false,
        keepAlive: true,
        saName: 'IntegralDetailsActivity'
      }
    },
    {
      path: '/sign',
      name: 'sign',
      component: resolve => require(['@/views/index/sign'], resolve),
      meta: {
        title: '签到',
        isBack: false,
        keepAlive: true,
        saName: 'SignActivity'
      }
    },
    {
      path: '/ideasDetail',
      name: 'ideasDetail',
      component: resolve => require(['@/views/ideas/ideasDetail'], resolve),
      meta: {
        title: '创意币获取明细',
        isBack: false,
        keepAlive: true,
        saName: 'ideasDetail'
      }
    },
    {
      path: '/copyrightIndex',
      name: 'copyrightIndex',
      component: resolve => require(['@/views/copyright/copyRightIndex'], resolve),
      meta: {
        title: '版权维权',
        keepAlive: true,
        saName: 'copyrightIndex'
      }
    },
    {
      path: '/copyrightService',
      name: 'copyrightService',
      component: resolve => require(['@/views/copyright/copyrightService'], resolve),
      meta: {
        title: '版权维权'
      }
    },
    {
      path: '/marketOnline/:type',
      name: 'marketOnline',
      component: resolve => require(['@/views/marketOnline/marketOnline'], resolve),
      meta: {
        title: '在线集市',
        isBack: false,
        keepAlive: true
      }
    },
    {
      path: '/market',
      name: 'market',
      component: resolve => require(['@/views/marketOnline/market'], resolve),
      meta: {
        title: '集市活动',
        isBack: false,
        keepAlive: true
      }
    },
    {
      path: '/ticketDetail',
      name: 'ticketDetail',
      component: resolve => require(['@/views/marketOnline/ticketDetail'], resolve),
      meta: {
        title: '门票详情',
        isBack: false,
        keepAlive: true
      }
    },
    {
      path: '/ticketBuy',
      name: 'ticketBuy',
      component: resolve => require(['@/views/marketOnline/ticketBuy'], resolve),
      meta: {
        title: '门票售卖',
        isBack: false,
        keepAlive: true
      }
    },
    {
      path: '/team/:type',
      name: 'team',
      component: resolve => require(['@/views/team/team'], resolve),
      meta: {
        title: '我的团',
        isBack: false,
        keepAlive: true
      }
    },
    {
      path: '/myTeam',
      name: 'myTeam',
      component: resolve => require(['@/views/team/myTeam'], resolve),
      meta: {
        title: '我的团首页',
        isBack: false,
        keepAlive: true
      }
    },
    {
      path: '/teamOrderDetail/:userId',
      name: 'teamOrderDetail',
      component: resolve => require(['@/views/team/teamOrderDetail'], resolve),
      meta: {
        title: '订单详情',
        isBack: false,
        keepAlive: true
      }
    },
    {
      path: '/teamConserveDetail/:type',
      name: 'teamConserveDetail',
      component: resolve => require(['@/views/team/teamConserveDetail'], resolve),
      meta: {
        title: '囤货详情',
        isBack: false,
        keepAlive: true
      }
    },
    {
      path: '/logDetail/:id',
      name: 'logDetail',
      component: resolve => require(['@/views/team/logDetail'], resolve),
      meta: {
        title: '兑换记录详情',
        isBack: false,
        keepAlive: true
      }
    },
    {
      path: '/exchangeDetail/:id',
      name: 'exchangeDetail',
      component: resolve => require(['@/views/team/exchangeDetail'], resolve),
      meta: {
        title: '兑换详情',
        isBack: false,
        keepAlive: true
      }
    },
    {
      path: '/QRcode',
      name: 'QRcode',
      component: resolve => require(['@/views/team/QRcode'], resolve),
      meta: {
        title: '邀请码',
        isBack: false,
        keepAlive: true
      }
    },
    {
      path: '/discover2',
      name: 'discover2',
      component: resolve => require(['@/views/discover/discover2'], resolve),
      meta: {
        title: '发现',
        isBack: false,
        keepAlive: true,
        saName: 'PintieMainActivity'
      }
    },
    {
      path: '/myTicket',
      name: 'myTicket',
      component: resolve => require(['@/views/marketOnline/myTicket'], resolve),
      meta: {
        title: '我的门票',
        isBack: false,
        keepAlive: true,
        saName: 'myTicket'
      }
    },
    {
      path: '/ticketOrderDetail',
      name: 'ticketOrderDetail',
      component: resolve => require(['@/views/marketOnline/ticketOrderDetail'], resolve),
      meta: {
        title: '支付订单详情',
        isBack: false,
        keepAlive: true
      }
    },
    {
      path: '/ticketQRcode/:id',
      name: 'ticketQRcode',
      component: resolve => require(['@/views/marketOnline/ticketQRcode'], resolve),
      meta: {
        title: '门票二维码',
        isBack: false,
        keepAlive: true
      }
    },
    // {
    //   path: '/sami2',
    //   name: 'sami2',
    //   component: resolve => require(['@/views/sami/sami2'], resolve),
    //   meta: {
    //     title: '撒米',
    //     isBack: false,
    //     keepAlive: true,
    //     saName: 'SaMiFragment'
    //   }
    // },
    {
      path: '/sami2',
      name: 'sami2',
      component: resolve => require(['@/views/sami/samiIdeas'], resolve),
      meta: {
        title: '撒米',
        isBack: false,
        keepAlive: true,
        saName: 'SaMiFragment'
      }
    },
    {
      path: '/pubPintie',
      name: 'pubPintie',
      component: resolve => require(['@/views/discover/pubPintie'], resolve),
      meta: {
        title: '发布拼贴',
        isBack: false,
        keepAlive: true,
        saName: 'PublishPingtieActivity'
      }
    },
    {
      path: '/pintieDetail/:id',
      name: 'pintieDetail',
      component: resolve => require(['@/views/discover/pintieDetail'], resolve),
      meta: {
        title: '拼贴详情',
        isBack: false,
        keepAlive: true,
        saName: 'PingtieDetailsActivity'
      }
    },
    {
      path: '/idleDetail/:id',
      name: 'idleDetail',
      component: resolve => require(['@/views/discover/pintieDetail'], resolve),
      meta: {
        title: '闲置详情',
        isBack: false,
        keepAlive: true
      }
    },
    {
      path: '/payTogether',
      name: 'payTogether',
      component: resolve => require(['@/views/order/payTogether'], resolve),
      meta: {
        title: '合并支付',
        isBack: false,
        keepAlive: true
      }
    },
    {
      path: '/memberDetail',
      name: 'memberDetail',
      component: resolve => require(['@/views/team/memberDetail'], resolve),
      meta: {
        title: '团员详情',
        isBack: false,
        keepAlive: true
      }
    },
    {
      path: '/pintuanOriginal/:type',
      name: 'pintuanOriginal',
      component: resolve => require(['@/views/pintuan/pintuanOriginal'], resolve),
      meta: {
        title: '原创产品',
        isBack: false,
        keepAlive: true
      }
    },
    {
      path: '/prizeDraw',
      name: 'prizeDraw',
      component: resolve => require(['@/views/score/prizeDraw'], resolve),
      meta: {
        title: '积分抽奖',
        isBack: false,
        keepAlive: true,
        saName: 'IntegralChoujiangActivity'
      }
    },
    {
      path: '/myPrize/:name',
      name: 'myPrize',
      component: resolve => require(['@/views/score/myPrize'], resolve),
      meta: {
        title: '我的奖品',
        isBack: false,
        keepAlive: true,
        saName: 'MyPrizeActivity'
      }
    },
    {
      path: '/prizeAddress/:id',
      name: 'prizeAddress',
      component: resolve => require(['@/views/score/prizeAddress'], resolve),
      meta: {
        title: '中奖地址',
        isBack: false,
        keepAlive: true
      }
    },
    {
      path: '/prizeDetail/:id',
      name: 'prizeDetail',
      component: resolve => require(['@/views/score/prizeDetail'], resolve),
      meta: {
        title: '奖品详情',
        keepAlive: true
      }
    },
    {
      path: '/relationProduct',
      name: 'relationProduct',
      component: resolve => require(['@/views/discover/relationProduct'], resolve),
      meta: {
        title: '文章相关产品',
        saName: 'AssociatedGoodsActivity'
      }
    },
    {
      path: '/subProductInfo',
      name: 'subProductInfo',
      component: resolve => require(['@/views/discover/subProductInfo'], resolve),
      meta: {
        title: '提交文章相关产品的信息'
      }
    },
    {
      path: '/discoverMain',
      name: 'discoverMain',
      component: resolve => require(['@/views/discover/discoverMain'], resolve),
      meta: {
        title: '发现首页1.5',
        isBack: false,
        keepAlive: true,
        saName: 'FindMiRingFragment'
      }
    },
    {
      path: '/washing',
      name: 'washing',
      component: resolve => require(['@/views/discover/washing'], resolve),
      meta: {
        title: '许愿池/文章列表页',
        keepAlive: true
      }
    },
    {
      path: '/pintie',
      name: 'pintie',
      component: resolve => require(['@/views/pintie/pintie'], resolve),
      meta: {
        title: '拼贴活动',
        keepAlive: true
      }
    },
    {
      path: '/racing',
      name: 'racing',
      component: resolve => require(['@/views/pintie/racing'], resolve),
      meta: {
        title: '拼贴赛道',
        keepAlive: true
      }
    },
    {
      path: '/makeRacing',
      name: 'makeRacing',
      component: resolve => require(['@/views/pintie/makeRacing'], resolve),
      meta: {
        title: '创意赛道',
        keepAlive: true
      }
    },
    {
      path: '/racingList',
      name: 'racingList',
      component: resolve => require(['@/views/pintie/racingList'], resolve),
      meta: {
        title: '赛道列表',
        keepAlive: true
      }
    },
    {
      path: '/pubPT',
      name: 'pubPT',
      component: resolve => require(['@/views/pintie/pubPT'], resolve),
      meta: {
        title: '发布拼贴赛',
        keepAlive: true
      }
    },
    {
      path: '/ptDetail/:id',
      name: 'ptDetail',
      component: resolve => require(['@/views/pintie/ptDetail'], resolve),
      meta: {
        title: '发布拼贴赛',
        keepAlive: true
      }
    },
    {
      path: '/zhiNan',
      name: 'zhiNan',
      component: resolve => require(['@/views/pintie/zhiNan'], resolve),
      meta: {
        title: '参赛指南',
        keepAlive: true
      }
    },
    {
      path: '/makeCreativePt',
      name: 'makeCreativePt',
      component: resolve => require(['@/views/pintie/makeCreativePt'], resolve),
      meta: {
        title: '开始排版',
        keepAlive: true
      }
    },
    {
      path: '/kefu',
      name: 'kefu',
      component: resolve => require(['@/views/my/kefu'], resolve),
      meta: {
        title: '客服',
        keepAlive: true
      }
    },
    {
      path: '/myCollect',
      name: 'myCollect',
      component: resolve => require(['@/views/my/myCollect'], resolve),
      meta: {
        title: ' 我的收藏',
        keepAlive: true,
        saName: 'MyFavoriteActivity'
      }
    },
    {
      path: '/myHistory',
      name: 'myHistory',
      component: resolve => require(['@/views/my/myHistory'], resolve),
      meta: {
        title: '浏览历史',
        keepAlive: true,
        saName: 'MyHistoryRecordActivity'
      }
    },
    {
      path: '/tagetherProduct',
      name: 'tagetherProduct',
      component: resolve => require(['@/views/pintuan/tagetherProduct'], resolve),
      meta: {
        title: '相关连商品',
        keepAlive: true
      }
    },
    {
      path: '/cp24download',
      name: 'cp24download',
      component: resolve => require(['@/views/cp24download/cp24download'], resolve),
      meta: {
        title: 'APP下载',
        keepAlive: true
      }
    },
    {
      path: '/bargainMain',
      name: 'bargainMain',
      component: resolve => require(['@/views/activity/bargainMain'], resolve),
      meta: {
        title: '砍价主页',
        keepAlive: true
      }
    },
    {
      path: '/bargainShare/:type/:productId',
      name: 'bargainShare',
      component: resolve => require(['@/views/activity/bargainShare'], resolve),
      meta: {
        title: '砍价分享',
        keepAlive: true
      }
    },
    {
      path: '/invalcoupon',
      name: 'invalcoupon',
      component: resolve => require(['@/views/activity/invalCouponM'], resolve),
      meta: {
        title: '瓜分米券首页',
        keepAlive: true
      }
    },
    {
      path: '/apppayout',
      name: 'apppayout',
      component: resolve => require(['@/views/apppayout/apppayout'], resolve),
      meta: {
        title: '原生app支付中间空白页',
        keepAlive: true
      }
    },
    {
      path: '/usercb0716',
      name: 'usercb0716',
      component: resolve => require(['@/views/cp24download/usercb0716'], resolve),
      meta: {
        title: '统计登录次数',
        keepAlive: true
      }
    },
    {
      path: '/ticketList',
      name: 'ticketList',
      component: resolve => require(['@/views/buyTicket/ticketList'], resolve),
      meta: {
        title: '活动列表',
        keepAlive: true
      }
    },
    {
      path: '/ticketDetails/:id',
      name: 'ticketDetails',
      component: resolve => require(['@/views/buyTicket/ticketDetails'], resolve),
      meta: {
        title: '购票详情',
        keepAlive: true
      }
    },
    {
      path: '/ifmticketList',
      name: 'ifmticketList',
      component: resolve => require(['@/views/buyTicket/ifmticketList'], resolve),
      meta: {
        title: '购票列表',
        keepAlive: true
      }
    },
    {
      path: '/makeCreative',
      name: 'makeCreative',
      component: resolve => require(['@/views/PlayCreative/makeCreative'], resolve),
      meta: {
        title: '我要定制',
        keepAlive: true
      }
    },
    {
      path: '/banner1',
      name: 'banner1',
      component: resolve => require(['@/views/PlayCreative/banner1'], resolve),
      meta: {
        title: '活动页面',
        keepAlive: true
      }
    },
    {
      path: '/banner2',
      name: 'banner2',
      component: resolve => require(['@/views/PlayCreative/banner2'], resolve),
      meta: {
        title: '活动获奖页',
        keepAlive: true
      }
    },
    {
      path: '/banner3',
      name: 'banner3',
      component: resolve => require(['@/views/PlayCreative/banner3'], resolve),
      meta: {
        title: '活动打卡页',
        keepAlive: true
      }
    },
    {
      path: '/banner4',
      name: 'banner4',
      component: resolve => require(['@/views/PlayCreative/banner4'], resolve),
      meta: {
        title: '国庆活动页',
        keepAlive: true
      }
    },
    {
      path: '/articleRouter/:id',
      name: 'articleRouter',
      component: resolve => require(['@/views/PlayCreative/articleRouter'], resolve),
      meta: {
        title: '文章跳转页',
        keepAlive: true
      }
    },
    {
      path: '/makeIndex',
      name: 'makeIndex',
      component: resolve => require(['@/views/PlayCreative/index'], resolve),
      meta: {
        title: ' 拼贴工具',
        keepAlive: true
      }
    },
    {
      path: '/makeCreative1',
      name: 'makeCreative1',
      component: resolve => require(['@/views/PlayCreative/makeCreative1'], resolve),
      meta: {
        title: '我要定制',
        keepAlive: true
      }
    },
    {
      path: '/creativeOrders',
      name: 'creativeOrders',
      component: resolve => require(['@/views/PlayCreative/creativeOrders'], resolve),
      meta: {
        title: '我要定制订单',
        keepAlive: true
      }
    },
    {
      path: '/userMsg',
      name: 'userMsg',
      component: resolve => require(['@/views/bsgroups/userMsg'], resolve),
      meta: {
        title: '社团信息',
        keepAlive: true
      }
    },
    {
      path: '/discoverV2',
      name: 'discoverV2',
      component: resolve => require(['@/views/discover/discoverV2'], resolve),
      meta: {
        title: '2.1发现首页',
        keepAlive: true
      }
    },
    {
      path: '/darenAuth/:step',
      name: 'darenAuth',
      component: resolve => require(['@/views/my/authentication'], resolve),
      meta: {
        title: '合作申请',
        keepAlive: true,
        saName: 'darenAuth'
      }
    },
    {
      path: '/associationIndex/:id',
      name: 'hiHousetTZ',
      component: resolve => require(['@/views/samiwu2.7/hiHousetTZ'], resolve),
      meta: {
        title: '首页跳转',
        keepAlive: true
      }
    },
    {
      path: '/toAssociation/:id',
      name: 'associationIndex',
      component: resolve => require(['@/views/association/index'], resolve),
      meta: {
        title: '社团首页',
        keepAlive: true
      }
    },
    {
      path: '/toProfit',
      name: 'toProfit',
      component: resolve => require(['@/views/my/toProfit'], resolve),
      meta: {
        title: '我的收益',
        keepAlive: true
      }
    },
    {
      path: '/ipProfit',
      name: 'ipProfit',
      component: resolve => require(['@/views/association/ipProfit'], resolve),
      meta: {
        title: '作品收益',
        keepAlive: true
      }
    },
    {
      path: '/goodsManage',
      name: 'goodsManage',
      component: resolve => require(['@/views/association/goodsManage'], resolve),
      meta: {
        title: '我的原创',
        keepAlive: true
      }
    },
    {
      path: '/associationProduct',
      name: 'associationProduct',
      component: resolve => require(['@/views/association/product'], resolve),
      meta: {
        title: '社团商品',
        keepAlive: true
      }
    },
    {
      path: '/associationArtList',
      name: 'associationArtList',
      component: resolve => require(['@/views/association/artList'], resolve),
      meta: {
        title: '社团创意',
        keepAlive: true
      }
    },
    {
      path: '/associationArtDetail/:id',
      name: 'associationArtDetail',
      component: resolve => require(['@/views/association/artDetail'], resolve),
      meta: {
        title: '创意画稿详情',
        keepAlive: true
      } }, {
      path: '/topic',
      name: 'topic',
      component: resolve => require(['@/views/discover/topic'], resolve),
      meta: {
        title: '热门话题/资讯',
        keepAlive: true
      }
    },
    {
      path: '/topicList',
      name: 'topicList',
      component: resolve => require(['@/views/discover/topicList'], resolve),
      meta: {
        title: '热门话题/资讯',
        keepAlive: true
      }
    },
    {
      path: '/editor',
      name: 'editor',
      component: resolve => require(['@/views/editor/editor'], resolve),
      meta: {
        title: '富文本编辑框',
        keepAlive: true
      }
    },
    {
      path: '/editors',
      name: 'editors',
      component: resolve => require(['@/views/pintie/editors'], resolve),
      meta: {
        title: '富文本编辑框',
        keepAlive: true
      }
    },
    {
      path: '/pubArticle',
      name: 'pubArticle',
      component: resolve => require(['@/views/editor/pubArticle'], resolve),
      meta: {
        title: '发布文章',
        keepAlive: true,
        saName: 'PublishArticleActivity'
      }
    },
    {
      path: '/pubArticles',
      name: 'pubArticles',
      component: resolve => require(['@/views/pintie/pubArticles'], resolve),
      meta: {
        title: '发布文章',
        keepAlive: true
      }
    },
    {
      path: '/myWalletDetail',
      name: 'myWalletDetail',
      component: resolve => require(['@/views/my/myWalletDetail'], resolve),
      meta: {
        title: '余额/米币',
        isBack: false,
        keepAlive: true,
        saName: 'MyWalletActivity'
      }
    },
    {
      path: '/smwMy',
      name: 'bshome',
      component: resolve => require(['@/views/samiHouse/bsmy'], resolve),
      meta: {
        title: '撒米屋我的',
        keepAlive: true
      }
    },
    {
      path: '/smw/recommend',
      name: 'recommend',
      component: resolve => require(['@/views/samiwu2.7/recommend'], resolve),
      meta: {
        title: '撒米屋推荐',
        keepAlive: true
      }
    },
    {
      path: '/smw/crowdfundingDetail/:id',
      name: 'crowdfundingDetail',
      component: resolve => require(['@/views/samiwu2.7/crowdfundingDetail'], resolve),
      meta: {
        title: '众筹详情',
        keepAlive: true
      }
    },
    {
      path: '/smw/worksDetail/:id',
      name: 'worksDetail',
      component: resolve => require(['@/views/samiwu2.7/worksDetail'], resolve),
      meta: {
        title: '作品信息',
        keepAlive: true
      }
    },
    {
      path: '/smw/miHouse/:id',
      name: 'miHouse',
      component: resolve => require(['@/views/samiwu2.7/miHouse'], resolve),
      meta: {
        title: '社团首页',
        keepAlive: true
      }
    },
    {
      path: '/smw/myProfit',
      name: 'miHouse',
      component: resolve => require(['@/views/samiwu2.7/myProfit'], resolve),
      meta: {
        title: '我的收益',
        keepAlive: true,
        saName: 'myProfit'
      }
    },
    {
      path: '/smw/paintingDetail/:id',
      name: 'paintingDetail',
      component: resolve => require(['@/views/samiwu2.7/paintingDetail'], resolve),
      meta: {
        title: '画稿详情',
        keepAlive: true
      }
    },
    {
      path: '/smw/miHouseWorksDetail/:id',
      name: 'miHouseWorksDetail',
      component: resolve => require(['@/views/samiwu2.7/miHouseWorksDetail'], resolve),
      meta: {
        title: '作品详情',
        keepAlive: true
      }
    },
    {
      path: '/smw/elementDetail/:id',
      name: 'elementDetail',
      component: resolve => require(['@/views/samiwu2.7/elementDetail'], resolve),
      meta: {
        title: '元素详情',
        keepAlive: true
      }
    },
    {
      path: '/smw/confirmOrder',
      name: 'confirmOrder',
      component: resolve => require(['@/views/samiwu2.7/confirmOrder'], resolve),
      meta: {
        title: '确认订单',
        keepAlive: true
      }
    },
    {
      path: '/smw/myMiHouse',
      name: 'confirmOrder',
      component: resolve => require(['@/views/samiwu2.7/myMiHouse'], resolve),
      meta: {
        title: '我的',
        keepAlive: true
      }
    },
    {
      path: '/smw/profitDetail',
      name: 'confirmOrder',
      component: resolve => require(['@/views/samiwu2.7/profitDetail'], resolve),
      meta: {
        title: '收益明细',
        keepAlive: true
      }
    },
    {
      path: '/game/redRain',
      name: 'redRain',
      component: resolve => require(['@/views/redRain/redRain'], resolve),
      meta: {
        title: '红包雨',
        keepAlive: true
      }
    },
    {
      path: '/newUserGift',
      name: 'newUserGift',
      component: resolve => require(['@/views/newUserGift/index'], resolve),
      meta: {
        title: '新人专享礼',
        keepAlive: true
      }
    },
    {
      path: '/postDrafts',
      name: 'postDraft',
      component: resolve => require(['@/views/samiHouse/postDraft'], resolve),
      meta: {
        title: '上传作品',
        keepAlive: true
      }
    },
    {
      path: '/ipLibrarys',
      name: 'ipLibrary',
      component: resolve => require(['@/views/samiHouse/ipLibrary'], resolve),
      meta: {
        title: '我的作品库',
        keepAlive: true
      }
    },
    {
      path: '/smwCreative',
      name: 'smwCreative',
      component: resolve => require(['@/views/PlayCreative/smwCreative'], resolve),
      meta: {
        title: '在线拼贴',
        keepAlive: true
      }
    },
    {
      path: '/wxdf/:orderId/:userId',
      name: 'wxdf',
      component: resolve => require(['@/views/order/wxdf'], resolve),
      meta: {
        title: '微信代支付',
        keepAlive: true
      }
    },
    {
      path: '/phoneLogin',
      name: 'phoneLogin',
      component: resolve => require(['@/views/login/phoneLogin'], resolve),
      meta: {
        title: '手机验证登录',
        keepAlive: true,
        saName: 'ThirdPartyLoginActivity'
      }
    },
    {
      path: '/phoneRegister',
      name: 'RegisterActivity',
      component: resolve => require(['@/views/login/phoneLogin'], resolve),
      meta: {
        title: '手机验证注册',
        keepAlive: true,
        saName: 'ThirdPartyLoginActivity'
      }
    },
    {
      path: '/draftDetails/:id',
      name: 'draftDetail',
      component: resolve => require(['@/views/samiHouse/draftDetail'], resolve),
      meta: {
        title: '详情',
        keepAlive: true
      }
    },
    {
      path: '/orderShowSuccess',
      name: 'orderShowSuccess',
      component: resolve => require(['@/views/order/orderShowSuccess'], resolve),
      meta: {
        title: '评价晒单',
        isBack: false,
        keepAlive: true
      }
    },
    {
      path: '/repurchase',
      name: 'repurchase',
      component: resolve => require(['@/views/pintuan/repurchase'], resolve),
      meta: {
        title: '换购商品',
        isBack: false,
        keepAlive: true
      }
    },
    {
      path: '/spellCrowd1',
      name: 'spellCrowd1',
      component: resolve => require(['@/views/pintuan/spellCrowd1'], resolve),
      meta: {
        title: '众筹/拼单主页',
        isBack: false,
        keepAlive: true,
        saName: 'spellCrowd'
      }
    },
    {
      path: '/newUserGift',
      name: 'newUserGift',
      component: resolve => require(['@/views/newUserGift/index'], resolve),
      meta: {
        title: '新人专享礼',
        keepAlive: true
      }
    },
    {
      path: '/userProfit',
      name: 'userProfit',
      component: resolve => require(['@/views/my/userProfit'], resolve),
      meta: {
        title: '个人收益',
        keepAlive: true
      }
    },
    {
      path: '/ipProfitNew',
      name: 'ipProfitNew',
      component: resolve => require(['@/views/my/ipProfit'], resolve),
      meta: {
        title: '作品收益',
        keepAlive: true
      }
    },
    {
      path: '/ipProfitWithdraw',
      name: 'ipProfitWithdraw',
      component: resolve => require(['@/views/my/ipProfitWithdraw'], resolve),
      meta: {
        title: '提现记录',
        keepAlive: true
      }
    },
    {
      path: '/skuProfitDetail/:id',
      name: 'skuProfitDetail',
      component: resolve => require(['@/views/my/skuProfitDetail'], resolve),
      meta: {
        title: '收益明细',
        keepAlive: true
      }
    },
    {
      path: '/fudaiList',
      name: 'fudaiList',
      component: resolve => require(['@/views/fudai/fudaiList'], resolve),
      meta: {
        title: '热门福袋',
        keepAlive: true
      }
    },
    {
      path: '/rollMachine',
      name: 'rollMachine',
      component: resolve => require(['@/views/fudai/rollMachine'], resolve),
      meta: {
        title: '抽袋机',
        keepAlive: true
      }
    },
    {
      path: '/relationSkuList/:id',
      name: 'relationSkuList',
      component: resolve => require(['@/views/pintuan/relationSkuList'], resolve),
      meta: {
        title: '关联列表',
        keepAlive: true
      }
    },
    {
      path: '/memberCenter',
      name: 'memberCenter',
      component: resolve => require(['@/views/member/memberCenter'], resolve),
      meta: {
        title: '会员中心',
        keepAlive: true,
        saName: 'memberCenter'
      }
    },
    {
      path: '/memberGift',
      name: 'memberGift',
      component: resolve => require(['@/views/member/memberGift'], resolve),
      meta: {
        title: '会员礼包',
        keepAlive: true
      }
    },
    {
      path: '/memberRule',
      name: 'memberRule',
      component: resolve => require(['@/views/member/memberRule'], resolve),
      meta: {
        title: '会员说明',
        keepAlive: true
      }
    },
    {
      path: '/doubleElevenIndex',
      name: 'doubleElevenIndex',
      component: resolve => require(['@/views/doubleEleven/index'], resolve),
      meta: {
        title: '新年主会场',
        keepAlive: true,
        isBack: false
      }
    },
    {
      path: '/consumes',
      name: 'consumes',
      component: resolve => require(['@/views/newYear/2023/consumes'], resolve),
      meta: {
        title: '消费得好券',
        keepAlive: true
      }
    },
    {
      path: '/inval2020/:pageType',
      name: 'inval2020',
      component: resolve => require(['@/views/anniversary/2020/invalAnni'], resolve),
      meta: {
        title: '邀请新用户',
        isBack: false,
        keepAlive: true
      }
    },
    {
      path: '/inval2022/:pageType',
      name: 'inval2022',
      component: resolve => require(['@/views/newYear/2022/inval2022'], resolve),
      meta: {
        title: '邀请新用户',
        isBack: false,
        keepAlive: true
      }
    },
    {
      path: '/inval2023/:pageType',
      name: 'inval2023',
      component: resolve => require(['@/views/newYear/2023/inval2023'], resolve),
      meta: {
        title: '邀请新用户',
        isBack: false,
        keepAlive: true
      }
    },
    {
      path: '/doubleElevenBranch',
      name: 'doubleElevenBranch',
      component: resolve => require(['@/views/doubleEleven/branch'], resolve),
      meta: {
        title: '新年分会场',
        keepAlive: true
      }
    },
    {
      path: '/pinkageRule',
      name: 'pinkageRule',
      component: resolve => require(['@/views/order/pinkageRule'], resolve),
      meta: {
        title: '包邮说明',
        keepAlive: true
      }
    },
    {
      path: '/my',
      name: 'my',
      component: resolve => require(['@/views/my/newMy'], resolve),
      meta: {
        title: '我的',
        keepAlive: true,
        saName: 'MeFragment'
      }
    },
    {
      path: '/',
      name: 'newIndex',
      component: resolve => require(['@/views/index/newIndex'], resolve),
      meta: {
        title: '首页',
        keepAlive: true,
        saName: 'MainFragmentRevision'
      }
    },
    {
      path: '/set',
      name: 'set',
      component: resolve => require(['@/views/my/set'], resolve),
      meta: {
        title: '设置',
        keepAlive: true,
        saName: 'SamiSetActivity'
      }
    },
    {
      path: '/pintuanSortList',
      name: 'pintuanSortList',
      component: resolve => require(['@/views/pintuan/pintuanSortList'], resolve),
      meta: {
        title: '主题列表',
        keepAlive: true
      }
    },
    {
      path: '/miquanSearch',
      name: 'miquanSearch',
      component: resolve => require(['@/views/discover/miquanSearch'], resolve),
      meta: {
        title: '米圈搜索',
        keepAlive: true,
        saName: 'MRingSearchActivity'
      }
    },
    {
      path: '/topicSelect',
      name: 'topicSelect',
      component: resolve => require(['@/views/discover/topicSelect'], resolve),
      meta: {
        title: '话题选择',
        keepAlive: true,
        saName: 'PublishSelectTopicActivity'
      }
    },
    {
      path: '/hotTopic',
      name: 'hotTopic',
      component: resolve => require(['@/views/discover/hotTopic'], resolve),
      meta: {
        title: '热门话题',
        keepAlive: true,
        saName: 'MRingHotTopicMoreActivity'
      }
    },
    {
      path: '/topicContribution',
      name: 'topicContribution',
      component: resolve => require(['@/views/discover/topicContribution'], resolve),
      meta: {
        title: '话题投稿',
        keepAlive: true,
        saName: 'PublishHotContributeActivity'
      }
    },
    {
      path: '/topicDetail/:id',
      name: 'topicDetail',
      component: resolve => require(['@/views/discover/topicDetail'], resolve),
      meta: {
        title: '话题详情',
        keepAlive: true,
        saName: 'HotTopicDetailActivity'
      }
    },
    {
      path: '/styleList',
      name: 'styleList',
      component: resolve => require(['@/views/discover/styleList'], resolve),
      meta: {
        title: '风格',
        keepAlive: true,
        saName: 'MRingMainStyleActivity'
      }
    },
    {
      path: '/styleDetail/:id',
      name: 'styleDetail',
      component: resolve => require(['@/views/discover/styleDetail'], resolve),
      meta: {
        title: '风格详情',
        keepAlive: true,
        saName: 'StyleDetailActivity'
      }
    },
    {
      path: '/idleIndex',
      name: 'idleIndex',
      component: resolve => require(['@/views/discover/idleIndex'], resolve),
      meta: {
        title: '闲置',
        keepAlive: true,
        saName: 'idleIndex'
      }
    },
    {
      path: '/pubIdle',
      name: 'pubIdle',
      component: resolve => require(['@/views/discover/pubIdle'], resolve),
      meta: {
        title: '发布闲置',
        keepAlive: true
      }
    },
    {
      path: '/idleReport',
      name: 'idleReport',
      component: resolve => require(['@/views/discover/idleReport'], resolve),
      meta: {
        title: '举报帖子',
        keepAlive: true
      }
    },
    {
      path: '/QAIndex',
      name: 'QAIndex',
      component: resolve => require(['@/views/discover/QAIndex'], resolve),
      meta: {
        title: '问答',
        keepAlive: true,
        saName: 'QAIndex'
      }
    },
    {
      path: '/pubQA',
      name: 'pubQA',
      component: resolve => require(['@/views/discover/pubQA'], resolve),
      meta: {
        title: '发布提问',
        keepAlive: true
      }
    },
    {
      path: '/QADetail/:id',
      name: 'QADetail',
      component: resolve => require(['@/views/discover/QADetail'], resolve),
      meta: {
        title: '问题详情',
        keepAlive: true
      }
    },
    {
      path: '/pubAnswer',
      name: 'pubAnswer',
      component: resolve => require(['@/views/discover/pubAnswer'], resolve),
      meta: {
        title: '我的回答',
        keepAlive: true
      }
    },
    {
      path: '/informationIndex',
      name: 'informationIndex',
      component: resolve => require(['@/views/discover/informationIndex'], resolve),
      meta: {
        title: '资讯',
        keepAlive: true,
        saName: 'MRingMainInformationActivity'
      }
    },
    {
      path: '/myPublish',
      name: 'myPublish',
      component: resolve => require(['@/views/my/myPublish'], resolve),
      meta: {
        title: '我的发布',
        keepAlive: true,
        saName: 'MyProductionActivity'
      }
    },
    {
      path: '/integralExchange',
      name: 'integralExchange',
      component: resolve => require(['@/views/coupon/integralExchange'], resolve),
      meta: {
        title: '兑换米券',
        keepAlive: true
      }
    },
    {
      path: '/conserveRule',
      name: 'conserveRule',
      component: resolve => require(['@/views/my/conserveRule'], resolve),
      meta: {
        title: '囤货收费说明',
        keepAlive: true
      }
    },
    {
      path: '/inviteShare',
      name: 'inviteShare',
      component: resolve => require(['@/views/invite/inviteShare'], resolve),
      meta: {
        title: '邀请好友',
        keepAlive: true
      }
    },
    {
      path: '/inviteShareAd',
      name: 'inviteShareAd',
      component: resolve => require(['@/views/invite/inviteShareAd'], resolve),
      meta: {
        title: '生成海报',
        keepAlive: true
      }
    },
    {
      path: '/wufuIndex',
      name: 'wufuIndex',
      component: resolve => require(['@/views/newYear/2021/wufu/index'], resolve),
      meta: {
        title: '五福首页',
        keepAlive: true
      }
    },
    {
      path: '/myFuka',
      name: 'myFuka',
      component: resolve => require(['@/views/newYear/2021/wufu/fuka'], resolve),
      meta: {
        title: '五福首页',
        keepAlive: true
      }
    },
    {
      path: '/newYear2022',
      name: 'newYear2022',
      component: resolve => require(['@/views/newYear/2022/index'], resolve),
      meta: {
        title: '2022新年主会场',
        keepAlive: true
      }
    },
    {
      path: '/newYear2022Branch',
      name: 'newYear2022Branch',
      component: resolve => require(['@/views/newYear/2022/branch'], resolve),
      meta: {
        title: '2022新年分会场',
        keepAlive: true
      }
    },
    {
      path: '/newYear2023',
      name: 'newYear2023',
      component: resolve => require(['@/views/newYear/2023/index'], resolve),
      meta: {
        title: '2023新年主会场',
        keepAlive: true
      }
    },
    {
      path: '/newYear2023Branch',
      name: 'newYear2023Branch',
      component: resolve => require(['@/views/newYear/2023/branch'], resolve),
      meta: {
        title: '2023新年分会场',
        keepAlive: true
      }
    },
    {
      path: '/towerGameInvite',
      name: 'towerGameInvite',
      component: resolve => require(['@/views/towerGame/invite'], resolve),
      meta: {
        title: '盖楼游戏邀请',
        keepAlive: true
      }
    },
    {
      path: '/otherLogin',
      name: 'otherLogin',
      component: resolve => require(['@/views/login/otherLogin'], resolve),
      meta: {
        title: '登录',
        keepAlive: true
      }
    },
    {
      path: '/payState/:orderId',
      name: 'payState',
      component: resolve => require(['@/views/order/payState'], resolve),
      meta: {
        title: '查询支付状态',
        keepAlive: true
      }
    },
    {
      path: '/recommendArticle/:title',
      name: 'recommendArticle',
      component: resolve => require(['@/views/discover/recommendArticle'], resolve),
      meta: {
        title: '推荐内容',
        keepAlive: true
      }
    },
    {
      path: '/activity/birdProject',
      name: 'birdProject',
      component: resolve => require(['@/views/activity/birdProject'], resolve),
      meta: {
        title: '拯救布谷鸟大计划',
        keepAlive: true
      }
    },
    {
      path: '/activity/seaDraw',
      name: 'seaDraw',
      component: resolve => require(['@/views/activity/seaDraw'], resolve),
      meta: {
        title: '海景混池赏',
        keepAlive: true
      }
    }
  ],
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      if (to.name !== 'index' && to.name !== 'discoverMain') {
        return {x: 0, y: 0}
      }
    }
  }
})



// WEBPACK FOOTER //
// ./src/router/index.js